import Helmet from 'react-helmet';
import React from 'react';

import './About.scss';

class About extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="about-wrapper">
        <Helmet>
          <title>Aloha50 | About</title>
        </Helmet>
        <div className="about">
          <div className="about__content">
            There are many companies doing a lot of good by tackling the issues we face today. Their success depends on the donations and volunteers they receive; however, at times that may prove to be difficult as the community may have a hard time relating to their cause. We started Aloha50 to help.<br /><br />
            Aloha50 brings people together over common concerns and stories that are expressed through art. Art is a universal language that has the power to change our perspective by reaching directly into our hearts. It may be challenging to relate to a charitable cause, but a painting of someone&apos;s personal story can start the conversation. We hope that Aloha50 will not only help bring awareness to the issues but also unite our communities.<br /><br />
            With Aloha50 we want to give artists the opportunity to share stories and express their views. We print their designs on apparel that others can wear and share around the world (encouraging more and more people to share their stories too!). Since it&apos;s not only about being able to relate to a cause, 50% of the proceeds from the apparel sales will go to charity.
          </div>
        </div>
      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/pages/About.jsx